<template>
  <v-container id="kidGiftsOverview" fluid class="pa-0">
    <CategoryBanner />
    <v-row no-gutters class="overview-container py-6">
      <v-col md="12" cols="12">
        <v-card flat tile>
          <v-row align="center" no-gutters class="mb-6">
            <v-col cols="12" md="12" class="d-flex justify-md-start justify-center">
              <div class="heading-h3">Rewards</div>
            </v-col>
            <v-col cols="12" md="12" class="d-flex justify-md-start justify-center">
              <div>Check out your cool rewards and wishlist!</div>
            </v-col>
          </v-row>
          <KidGiftsInfoTabs />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import KidGiftsInfoTabs from "@/components/Kids/KidGiftsInfoTabs";
  import CategoryBanner from "@/components/Catalog/CategoryBanner";

  export default {
    name: "KidGiftsOverview",

    components: { KidGiftsInfoTabs, CategoryBanner },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidGiftsOverview.vue